import { render, staticRenderFns } from "./MaterialsLayout.vue?vue&type=template&id=e5c09ace&scoped=true"
import script from "./MaterialsLayout.vue?vue&type=script&lang=js"
export * from "./MaterialsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c09ace",
  null
  
)

export default component.exports